// import { configureStore as configureReduxStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';

import requestCache from './middleware/requestCache';
import requestsChecker from './middleware/requestsChecker';
import rootReducer from './reducers';

const mapPayload = payload => Array.isArray(payload)
  ? (payload.length > 30 ? payload.length : payload)
  : Object.keys(payload).reduce((o, k) => {
    const prop = payload[k];
    o[k] = Array.isArray(prop) ? prop.length : Object.keys(prop || {})
    return o;
  }, {});

function actionSanitizer(action) {
  return action.payload ? { ...action, payload: mapPayload(action.payload) } : action;
}

function stateSanitizer(state) {
  return state.data ? { ...state, data: mapPayload(state.data) } : state;
}

export default function configureStore(preloadedState) {
  const store = configureReduxStore({
    reducer: rootReducer,
    // The default middleware would help us check proper use of redux code,
    // but it slows down development with larger data sets too much.
    // Anyway, do toggle this on occasionally!
    // middleware: [requestCache, ...getDefaultMiddleware(), requestsChecker],
    middleware: [requestCache, thunk, requestsChecker],
    devTools: { actionSanitizer, stateSanitizer },
    preloadedState,
  });

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }
  return store;
};

